// Shared example values for lead form fields — used to fill in realistic-looking placeholders
// wherever a "here's what the body/preview looks like" example is shown (formTemplates/edit.tsx's
// Design Studio preview, its "Intégration API" tab and CSV export, and the seller generic API's
// docs page), so the same field always gets the same illustrative value everywhere.
export const FIELD_PLACEHOLDERS: Record<string, string> = {
    'Prénom': 'Jean', 'Nom': 'Dupont', 'Téléphone': '06 12 34 56 78',
    'Email': 'jean@exemple.com', 'Code postal': '75001', 'Département': 'Paris (75)',
    'Adresse': '12 rue de la Paix', 'Ville': 'Paris', 'Message': 'Votre message...',
    'Surface': '120 m²', 'Budget': '250 000 €', 'Type de bien': 'Appartement',
    'Projet': 'Achat résidence principale', 'Situation professionnelle': 'Salarié',
    'Revenus': '3 500 € / mois', 'Apport': '50 000 €', 'Date de naissance': '01/01/1985',
    'Nombre de personnes': '3', 'Type de contrat': 'CDI',
};

// Matches leadCatcher/index.ts's EMAIL_FIELD_REGEX — used to recognize an email field by its
// label so a live API tester can default it to Leadrs' no-op test address (see below).
export const EMAIL_FIELD_REGEX = /^(email|mail|adresse_mail|e-mail)$/i;

// A submission with this exact value in ANY field is treated as a connectivity test rather than
// a real lead — see leadCatcher/index.ts's isTestingIntegration('testing@leadrs.co'). It creates
// a harmless Lead record (orderNumber 'TEST', leadQualityStatus 'test') instead of being scored,
// checked for duplicates/blocked answers, or routed to a buyer, and returns the same 200 shape
// as a real submission.
export const TEST_EMAIL = 'testing@leadrs.co';

export interface FieldTypeInfo {
    type?: string;
    options?: string[];
}

// A select/multi-select field's own first option is a more useful example than free text (it's
// guaranteed to be an accepted value); everything else falls back to the label-keyed placeholder
// map, or a generic "Exemple" when the label isn't one we have a canned value for.
export const fieldExampleValue = (label: string, field?: FieldTypeInfo): string => {
    if ((field?.type === 'select' || field?.type === 'multi-select') && field.options?.length) {
        return field.options[0];
    }
    return FIELD_PLACEHOLDERS[label] ?? 'Exemple';
};
